import { useMsal } from '@azure/msal-react';
import { Axios } from 'axios';
import * as log from 'loglevel';

import { msalConfig, loginRequest } from '../../authConfig';
import { oimApiConfig } from '../../config';

const apiSubscriptionKey = oimApiConfig.apiSubscriptionKey;

export async function useAuthorization(http: Axios): Promise<void> {
  const { instance } = useMsal();

  http.interceptors.request.use(async config => {
    const accounts = instance.getAllAccounts();

    if (accounts.length > 0) {
      try {
        const response = await instance.acquireTokenSilent({
          authority: msalConfig.auth.authority,
          scopes: loginRequest.scopes,
          account: accounts[0],
        });

        config.headers.Authorization = `Bearer ${response.accessToken}`;
      } catch (error) {
        log.error('Error acquiring token silently', error);
      }
    }

    config.headers['api-key'] = apiSubscriptionKey;
    return config;
  });
}
